import React from 'react';

import { Box } from '@material-ui/core';

import { GroupManageAnnotationsActions } from './GroupManageAnnotationsActions';
import { GroupOwnershipActions } from './GroupOwnershipActions';

export const GroupEntityActionMenu = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        p: 0,
        m: 0,
        borderRadius: 0,
      }}
    >
      <GroupOwnershipActions />
      <GroupManageAnnotationsActions />
    </Box>
  );
};
